<template>
  <div class="field">
    <div class="field__inner">
      <CardPlaceHolder
        v-for="(tableCards, index) in tableCards"
        v-bind:key="index"
        v-bind:type="'tableCard'"
        v-bind:position="index"
        v-bind:active="true"
        v-bind:nextNumber="tableCards.nextNumber"
        v-bind:cardLength="tableCards.cards.length"
      >
        <Card v-bind:card="tableCards.cards[tableCards.cards.length - 1]" />
      </CardPlaceHolder>
      <CardPlaceHolder v-bind:cardLength="tableStock.length">
        <Card v-bind:stock="true" />
      </CardPlaceHolder>
    </div>
  </div>
</template>

<script>
import CardPlaceHolder from './shared/CardPlaceHolder.vue';
import Card from './shared/Card.vue';
import { mapState } from 'vuex';
export default {
  components: {
    CardPlaceHolder,
    Card
  },
  computed: mapState(['tableCards', 'tableStock'])
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  display: flex;
  z-index: 2;

  &__inner {
    display: inline-flex;
    margin: 0 -15px;
  }
}
</style>
